// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1JKby","content":"styles_content__RNFqj","checkbox":"styles_checkbox__Ua4jY","checkboxLabel":"styles_checkboxLabel__3I_bb"};